<template>
    <div @click="praise()"  class="vCenter zanbtndiv">
      <img :src="minezan=='0'?'/img/icon/zan.png':'/img/icon/zaned.png'" alt="">
      <div class="btntext" v-if="praisecount==0">
        赞
      </div>
      <div class="btntext" v-else>
        {{praisecount}}
      </div>
    </div>
</template>
<script>
export default {
  name: "UmZan",
  data() {
    return {
      reviewtype:0,
      umid: '',
      // minezan: 0,
      // praisecount: 0,
      edittype: 0,
    };
  },
  props: ["sid","appid","minezan","praisecount"],
  mounted() {
    var that = this;
    that.umid=$UMCore.uncompile("umid")
    var waitReady = function() {
      if (that.sid != '' && that.sid != undefined) {
        if ($UMCore.uncompile('token')!=null) {
            var opt = localStorage.getItem("newsoperate")
            if(opt == 1) {
              that.praise()
            }
        }
        localStorage.removeItem("newsoperate") 
      } else {
        setTimeout(function() {
          waitReady();
        }, 20);
      }
    };
    setTimeout(function() {
      waitReady();
    }, 50);
    
  },
  methods: {
    /**
     * 获取新闻相关内容（详情，评论）
     */
    api(){
      var that=this
      $UMCore
        .post("/route.lua", {
         data:JSON.stringify({
            functionname:"comments_set",
            dappid:that.appid,
            edittype:that.edittype,
            dappuuid: that.sid,
            itype: that.reviewtype,
            stext:"",
            umid:that.umid,
            parentid:""
         })
        })
        .then(function(response) {
          if (response.data.status) {
            that.usercomments = ''
          } else {
            that.$message({ message: '失败', type: 'error', customClass: 'popupMessage' })
          }
        })
        .catch(function(error) {
          console.log(error);
          that.$message.error("网络错误！");
          return false;
        });
    },
    /**
     * 新闻详情的点赞切换
     */
    praise(){
        if ($UMCore.uncompile('token')==null) {
            localStorage.setItem("newsoperate", 1)
            this.$emit('unlogin','');
            // this.openloginview()
        } else {
            if(this.minezan=='0'){
                this.praisecount=parseInt(this.praisecount)+1;
                this.minezan='1';
                this.reviewtype='0';
                this.api();
            }else{
                this.praisecount=parseInt(this.praisecount)-1;
                this.minezan='0';
                this.reviewtype='0';
                this.api();
            }
        }
    },
  }
};
</script>
<style lang="scss" scoped>
.zanbtndiv {
  cursor: pointer;
  margin-left: 16px;
  img {
    width: 16px;
    height: 16px;
  }
  .btntext {
    margin-left: 4px;
    font-size: 12px;
    color: #999;
  }
}
</style>




// WEBPACK FOOTER //
// src/packages/zan/um-zan.vue